import { Checkbox } from 'antd'
import styles from './bookingSlot.module.scss'
import { formatMoney } from 'common/services/format'
import type { BaseSlot } from 'features/Booking/components/BookingSlots/BookingSlotGroup'

interface Props<T extends BaseSlot> {
  slot: T
  isSelected: boolean
  onToggle: () => void
  isDisabled?: boolean
}

export const BookingSlot = <T extends BaseSlot>({
  slot,
  isSelected,
  onToggle,
  isDisabled: isDisabledProp,
}: Props<T>) => {
  const isActive = !!slot.is_active
  const isDisabled = (isDisabledProp || !isActive) && !isSelected
  return (
    <div
      className={styles.slot}
      data-selected={isSelected}
      data-is-active={!isDisabled}
      onClick={() => {
        if (!isDisabled) {
          onToggle()
        }
      }}>
      <Checkbox className={styles.checkbox} disabled={isDisabled} checked={isSelected} />
      <span className={styles.slotTitle}>{slot.title}</span>
      <span className={styles.slotPrice}>
        {slot.priceLabel ? <span className={styles.slotPriceLabel}>{slot.priceLabel}</span> : null}
        {slot?.price >= 0 && <> {formatMoney(slot.price)} </>}
      </span>
    </div>
  )
}
